<template>
    <div class="d-flex flex-column w-100">
        <nav-bar/>
        <banner titulo="Meus Dados" subTitulo="Perfil"/>
        <div class="d-flex flex-column w-75 mx-auto borda" style="justify-content: flex-start;">
        <div class="p-2 mb-5 d-flex gap-sm">
            <b-dropdown class="mx-1" variant="dark" right text="Editar Perfil" boundary="window">
                <b-dropdown-item @click="habilitarEdicao" class="d-flex">Editar Perfil</b-dropdown-item>
                <b-dropdown-item @click="habilitarAlterarSenha" class="d-flex">Alterar Senha</b-dropdown-item>
            </b-dropdown>
            <b-button variant="primary" @click="limpaEstados" v-if="podeAlterarSenha || podeEditarPessoaFisica || podeEditarPessoaJuridica">Voltar</b-button>
        </div>
        <div class="text-center text-primary my-2" v-show="carregando">
            <b-spinner class="align-middle"></b-spinner>
        </div>

        <div class="w-100 px-2 d-flex flex-column gap-sm" v-if="verificaTipoPessoa == 'PessoaFisica' && !podeAlterarSenha && !carregando">
			<div>
				<span id="disabled-wrapper2">
					<span>
						Dúvidas:
					</span>
					 <font-awesome-icon :icon="['fass', 'circle-info']" style="font-size:18px"/>
				</span>
				<b-tooltip target="disabled-wrapper2" v-if="!usuario.funcionarioPrimeseg">Alguns campos só podem ser alterados pela nossa equipe. Se você deseja fazer alterações, entre em contato conosco e solicite a alteração.</b-tooltip>
				<b-tooltip target="disabled-wrapper2" v-else>Alguns campos só podem ser alterados na página de Gerenciar Pessoas.</b-tooltip>
			</div>
            <b-row>
				<b-col md="6">
                    <label>Email:</label>
					<input disabled v-model="usuario.email" type="text" class="form-control">
				</b-col>
                <b-col md="6">
                    <label>Cpf:</label>
                    <input v-mask="'###.###.###-##'" disabled v-model="usuario.cpf" type="text" class="form-control">
                </b-col>
            </b-row>
			<b-row v-if="!usuario.funcionarioPrimeseg">
				<b-col md="6" sm="12">
					<label>Tipo Específico:</label>
					<select v-model="usuario.tipoEspecifico" class="form-control" disabled>
                		<option value selected disabled>Selecione</option>
                		<option value="CEI">CEI</option>
                		<option value="CAEPF">CAEPF</option>
                		<option value="CNO">CNO</option>
            		</select>
				</b-col>
				<b-col md="6" sm="12">
					<label>Código {{ usuario.tipoEspecifico ? usuario.tipoEspecifico : "" }}:</label>
					<input disabled type="text" class="form-control" v-model="usuario.codigo">
				</b-col>
			</b-row>
            <b-row>
                <b-col md="6">
                    <label>Nome Completo:</label>
                    <input :disabled="!podeEditarPessoaFisica" v-model="usuario.nome" type="text" class="form-control">
                </b-col>
                <b-col md="6">
                    <label>Telefone:</label>
                    <the-mask v-model="usuario.telefone" :mask="['(##) ####-####' , '(##) #####-####']" :disabled="!podeEditarPessoaFisica" type="text" class="form-control" />
                </b-col>
            </b-row>
			<b-row>
				<b-col>
					<label>Estado:</label>
					<select-estados :value="usuario.estado" :disabled="!podeEditarPessoaFisica" @estadoSelecionado="selecionaEstado($event)"/>
				</b-col>
				<b-col>
					<label>Cidade:</label>
					<auto-complete-cidade :value="usuario.cidade" :disabled="!podeEditarPessoaFisica" @cidadeSelecionada="selecionaCidade($event)"/>
				</b-col>
			</b-row>
        </div>
        <div class="w-100 px-2 d-flex flex-column gap-sm" v-if="verificaTipoPessoa == 'PessoaJuridica' && !podeAlterarSenha && !carregando">
			<div>
				<span id="disabled-wrapper">
					<span>
						Dúvidas:
					</span>
					<font-awesome-icon :icon="['fass', 'circle-info']" style="font-size:18px"/>
				</span>
				<b-tooltip target="disabled-wrapper">Alguns campos só podem ser alterados por nossa equipe. Caso queira realizar a alteração entre em contato conosco e solicite a alteração.</b-tooltip>
			</div>
            <b-row>
                <b-col md="6">
                    <label>Email:</label>
                    <input disabled type="text" class="form-control" v-model="usuario.email">
                </b-col>
                <b-col md="6">
                    <label>Cnpj:</label>
                    <input type="text" class="form-control" v-mask="'##.###.###/####-##'" disabled v-model="usuario.cnpj">
                </b-col>
            </b-row>
            <b-row>
				<b-col md="6">
                    <label>Razão Social:</label>
                    <input :disabled="!podeEditarPessoaJuridica" v-model="usuario.razaoSocial" type="text" class="form-control">
                </b-col>
                <b-col md="6">
                    <label>Telefone:</label>
                    <the-mask :mask="['(##) ####-####' , '(##) #####-####']" :disabled="!podeEditarPessoaJuridica" type="text" class="form-control" v-model="usuario.telefone"/>
                </b-col>
            </b-row>
			<b-row>
				<b-col md="6" sm="12">
					<label>Estado:</label>
					<select-estados :value="usuario.estado" :disabled="!podeEditarPessoaJuridica" @estadoSelecionado="selecionaEstado($event)"/>
				</b-col>
				<b-col md="6" sm="12">
					<label>Cidade:</label>
					<auto-complete-cidade :value="usuario.cidade" :disabled="!podeEditarPessoaJuridica" @cidadeSelecionada="selecionaCidade($event)"/>
				</b-col>
			</b-row>
        </div>
        <div class="px-2 mt-3" v-if="(podeEditarPessoaFisica || podeEditarPessoaJuridica) && !carregando">
            <b-button variant="success" @click="editarDadosUsuario" :disabled="carregandoSalvarUsuario">
                <b-spinner v-show="carregandoSalvarUsuario" variant="light"></b-spinner>
                <span v-show="!carregandoSalvarUsuario">
                    Salvar
                </span>
            </b-button>
        </div>
            <b-row v-if="podeAlterarSenha" class="px-2 d-flex flex-column gap-sm">
                <b-col md="12" class="mb-1">
                    <label>Digite Sua Senha Atual:</label>
                    <input type="password" placeholder="Digite sua Senha Atual" v-model="alteracaoSenha.senha" class="form-control">
                </b-col>
                <b-col md="12" class="mb-1">
                    <label>Digite Sua Nova Senha:</label>
                    <input type="password" placeholder="Digite sua Nova Senha" v-model="alteracaoSenha.novaSenha" class="form-control">
                </b-col>
                <b-col md="12" class="mb-1">
                    <label>Confirme Sua Nova Senha:</label>
                    <input type="password" placeholder="Digite sua Nova Senha" v-model="alteracaoSenha.confirmacaoNovaSenha" class="form-control">
                </b-col>
                <b-col cols="3">
                    <b-button :disabled="carregandoAlterarSenha" variant="success" @click="alteraSenha">
                        <b-spinner v-show="carregandoAlterarSenha" variant="light"></b-spinner>
                        <span v-show="!carregandoAlterarSenha">
                            Alterar Senha
                        </span>
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Usuario from "../../model/Usuario.js";
import UsuarioService from "../../service/UsuarioService.js";
import AlterarSenha from "../../model/AlterarSenha.js";
import AuthService from "../../service/AuthService.js";
import Banner from "../../components/shared/Banner.vue";
import NavBar from "../../components/shared/NavBar.vue";
import AutoCompleteCidade from "../../components/shared/AutoCompleteCidade.vue";
import SelectEstados from "../../components/shared/SelectEstados.vue";


export default {
	components: { Banner, NavBar, AutoCompleteCidade, SelectEstados },
	name: "GerenciarUsuarios",
 		data() {
		return {
			usuarioLogado: JSON.parse(localStorage.getItem("usuario")),
			usuario: new Usuario(),

			carregando: false,

			podeEditarPessoaFisica: false,
			podeEditarPessoaJuridica: false,
			podeAlterarSenha: false,

			alteracaoSenha: new AlterarSenha(),
			carregandoAlterarSenha: false,

			carregandoSalvarUsuario: false,
		};
	},
	created() {
		this.buscarUsuarioPorId();
	},
	computed: {
		verificaTipoPessoa() {
			return this.usuario.razaoSocial == null && this.usuario.cnpj == null ? "PessoaFisica" : "PessoaJuridica";
		},

	},
	methods: {
		selecionaCidade(value) {
			this.usuario.cidade = value;
		},
		selecionaEstado(value) {
			this.usuario.estado = value;
		},
		editarDadosUsuario() {
			this.carregandoSalvarUsuario = true;

			const usuario = {
				id: this.usuario.id,
	            email: this.usuario.email,
	            nome: this.usuario.nome,
				razaoSocial: this.usuario.razaoSocial,
	            telefone: this.$options.filters.removeMascara(this.usuario.telefone),
				cidade: this.usuario.cidade,
				estado: this.usuario.estado,
			};

			AuthService.atualizarDadosPessoais(usuario, this.usuarioLogado.id)
				.then(() => {
					this.podeEditarPessoaFisica = false;
					this.podeEditarPessoaJuridica = false;
					this.mensagem("Perfil Atualizado Com Sucesso!", "Sucesso", "success");
				}).catch(() => {
					this.mensagem("Não foi possível atualizar as informações de perfil!", "Erro", "danger");
				})
				.finally(() => {
					this.carregandoSalvarUsuario = false;
				});
		},
		habilitarAlterarSenha() {
			this.podeEditarPessoaFisica = false;
			this.podeEditarPessoaJuridica = false;
			this.podeAlterarSenha = true;
		},
		alteraSenha() {
			this.carregandoAlterarSenha = true;
			AuthService.alterarSenha(this.usuarioLogado.id, this.alteracaoSenha, this.usuarioLogado.id)
				.then(() => {
					this.alteracaoSenha = new AlterarSenha();
					this.podeAlterarSenha = false;
					this.mensagem("Senha Alterada Com Sucesso!", "Sucesso", "success");
				}).catch((err) => {
					this.mensagem(err.response.data, "Aviso", "warning");
				}).finally(() => {
					this.carregandoAlterarSenha = false;
				});
		},
		async habilitarEdicao() {
			const tipoUsuario = this.verificaTipoPessoa;
			this.podeAlterarSenha = false;
			this.buscarUsuarioPorId().then(() => {
				if (tipoUsuario == "PessoaFisica") {
					this.podeEditarPessoaFisica = true;
				} else {
					this.podeEditarPessoaJuridica = true;
				}
				console.log(this.podeEditarPessoaJuridica);
			});
		},
		async buscarUsuarioPorId() {
			this.carregando = true;
			UsuarioService.consultarUsuarioPorId(this.usuarioLogado.id)
				.then((res) => {
					this.usuario = res.data;
				})
				.finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
		limpaEstados() {
			this.podeAlterarSenha = false;
			this.podeEditarPessoaFisica = false;
			this.podeEditarPessoaJuridica = false;
		},
	},
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.borda {
    box-shadow: 0px 0px 2px 0px grey;
    min-height: 80vh;
    justify-content: center;
}

h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>




// WEBPACK FOOTER //
// src/views/usuario/Perfil.vue